/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%]{background-color:#0080ff;line-height:1.25rem}.modal-title[_ngcontent-%COMP%]{font-size:1.15rem;color:#fff}.modal-body[_ngcontent-%COMP%]{max-height:80vh;overflow-y:auto;padding:0}.close-btn[_ngcontent-%COMP%]{background:transparent;border:0;outline:none;padding:0;cursor:pointer}.close-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:1.8rem;color:#fff}"];
export { styles as styles };
//# sourceMappingURL=writing-feedback-request-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/writing-feedback-request-modal/writing-feedback-request-modal.component.scss.shim.ngstyle.js
// module id = 1296
// module chunks = 27 28 29